import { render, staticRenderFns } from "./SecondCombinedStep.vue?vue&type=template&id=4869fec8&"
import script from "./SecondCombinedStep.vue?vue&type=script&lang=js&"
export * from "./SecondCombinedStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports